import { Close } from "@mui/icons-material";
import { DialogTitle, DialogTitleProps, IconButton } from "@mui/material";
import React from "react";

interface DialogHeaderProps extends DialogTitleProps {
  children?: React.ReactNode;
  onClose: () => void;
}

const DialogHeader: React.FC<DialogHeaderProps> = ({
  children,
  onClose,
  ...other
}) => {
  return (
    <DialogTitle
      component="div"
      {...other}
      sx={{
        m: 0,
        p: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: (theme) =>
          theme.palette.mode === "dark" ? theme.palette.grey[900] : theme.palette.grey[100],
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        ...other.sx,
      }}
    >
      <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}>
        {children}
      </div>
      <IconButton
        id="closeicon-task"
        aria-label="close"
        onClick={onClose}
        sx={{
          flex: 0,
        }}
      >
        <Close />
      </IconButton>
    </DialogTitle>
  );
};

export default DialogHeader;
